module.exports = __webpack_public_path__ + "static/media/twitterX.d845d52e.svg";